import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { useLang } from '~/stores/i18n';

const HostStatusRedirect = () => {
  const lang = useLang();
  return (
    <Navigate
      to={generatePathnameWithLangCode(`/host/status/`, lang)}
      replace
    />
  );
};

const routes = (
  <Route
    key={'host-status-redirect'}
    path={`${basePath}/host/manage-status`}
    element={<HostStatusRedirect />}
  />
);

export default routes;
